import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { firestore as db } from "../config/Config";



export const fetchQuotationList = createAsyncThunk(
  'fetchquotes',
  async ({ clientUID, roomName, page = 1, lim = 10 }) => {
    if (!clientUID) {
      return { quotes: [], currentPage: 1, hasNextPage: false };
    }

    try {
      const quotationsRef = db.collection('client').doc(clientUID).collection('Quotations');
      let snapshot;
      try {
        snapshot = await quotationsRef.orderBy('timestamp', 'desc').get();
      } catch (orderErr) {
        snapshot = await quotationsRef.get();
      }

      const quotes = [];
      snapshot.forEach((doc) => {
        const docData = doc.data();
        if (roomName === 'assignRoom') {
          if (docData.quotiationAssignedStatus) {
            quotes.push({ ID: doc.id, ...docData });
          }
        } else {
          quotes.push({ ID: doc.id, ...docData });
        }
      });

      return {
        quotes,
        currentPage: Number(page) || 1,
        hasNextPage: false,
      };
    } catch (error) {
      console.error('Error fetching quotations:', error);
      return { quotes: [], currentPage: Number(page) || 1, hasNextPage: false };
    }
  }
);

const quotationReducer = createSlice({
  name: 'viewquotes',
  initialState: {
    data: { quotes: [], currentPage: 1, hasNextPage: false },
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuotationList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchQuotationList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload || { quotes: [], currentPage: 1, hasNextPage: false };
        state.error = null;
        console.log("redux data in", state.data);
      })
      .addCase(fetchQuotationList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message;
        state.data = { quotes: [], currentPage: 1, hasNextPage: false };
      });
  },
});

export default quotationReducer.reducer